// Modules
import React, {useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams, Redirect } from 'react-router-dom';

// Actions
import {
	getDomainField,
	getEvents,
	updateRequestUrl,
} from '../../store/reducers/event.reducer';

// Components
import Event from '../event/event.component';
import NoResult from '../no-result/no-result.component';
import Loading from '../loading/loading.component';

// Styled Components
import { EventListView } from './event-list.styles';

// Types
import { QueryFilters } from '../../types/query-filters';

// Constant
import Constant from '../../constants/contant';
import {isValidLang} from '../../utils/common.utils';

//Reducers
import {
	SET_DIRECTION,
	SET_LANGUAGE,
} from '../../store/reducers/common.reducer';
import { getHighlightEvent } from '../../store/reducers/event.reducer';

const EventList = () => {

	const events: any[] = useSelector((state: any) => state.event.list);
	const domainUnit = useSelector((state: any) => state.event.eventDomainField);
	const requestUrl = useSelector((state: any) => state.event.requestUrl);
	const hasFacetLoaded = useSelector((state: any) => state.event.facetsLoaded);
	const lang = useSelector((state: any) => state.common.lang);
	const loading = useSelector((state: any) => state.event.loading);
	const facets = useSelector((state: any) => state.facet.data);

	const dispatch = useDispatch();

	const location = useLocation();
	const params:any = useParams();

	useEffect(()=>{
		if(params.domainUnit){
			dispatch(getDomainField(params.domainUnit));
		}
	}, []);
	
	useEffect(() => {
		let language = params.lang === 'en' || params.lang ===  'fr' ? 'en' : 'he';		
		const direction = language === 'en'  ? 'ltr' : 'rtl';
		let searchQuery = location.search;
		
		document.documentElement.lang = language;
		document.documentElement.dir = direction;
		dispatch({ type: SET_DIRECTION.type, payload: direction });
		dispatch({ type: SET_LANGUAGE.type, payload: language });
		if(params.organizingUnit) {
			searchQuery = `${searchQuery}&organizingUnit=${params.organizingUnit}`
		}

		if(params.domainUnit) {
			searchQuery = `${searchQuery}&organizingUnit=${domainUnit}`
		}

		searchQuery = !location.pathname.includes('past') ? `${searchQuery}&eventStatus=active,not_active_future` :  `${searchQuery}&eventStatus=not_active_past`  
	
		const type = location.pathname.includes('past') ? 'past' : 'future'
		if (hasFacetLoaded) {

			const query = new QueryFilters(searchQuery, facets, type);
			dispatch(
				updateRequestUrl(
					`${Constant.API_BASE_URL}${lang === 'en' ? 'en/' : ''}${
						Constant.EVENTS_BASE_PATH
					}${Constant.INCLUDES}${query.drupalQueryString}`,
				),
			);
		}
	}, [hasFacetLoaded, location]);
	
	useEffect(() => {
		dispatch(getEvents(requestUrl));
	}, [requestUrl]);

	useEffect(() => {
		dispatch(getHighlightEvent());		
	}, [dispatch, requestUrl])

	if (params.lang && !isValidLang(params.lang)){
		return <Redirect to={`/`} />
	}

	if (!events.length && !loading) {
		return <NoResult />;
	}

	if (loading) {
		return <Loading />;
	}

	return (
		<EventListView>
			{events.map((event, index) => {
				return <Event {...event} key={index} />;
			})}
		</EventListView>
	);
};

export default EventList;
